import SchedulerCourseSectionService from "../SchedulerCourseSection/SchedulerCourseSection.service";
export default class CourseService {
    static getSchedulableSet(course, sections) {
        return {
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'string'.
            id: course.id,
            type: "Course",
            children: sections.map(SchedulerCourseSectionService.getSchedulableSet),
        };
    }
}
